import moment from "moment-timezone";
import { offsetParts } from "./components/ShowDetailOffset";

// ponytail: mirrors ShowActivity::REQUIRED's wording for these four keys. Serve
// it from the presenter if the two ever drift.

export const SERIES_ACTIVITIES = [
  { key: "announce_time", label: "Announce" },
  { key: "venue_pre_sale_time", label: "Venue Pre-Sale" },
  { key: "artist_pre_sale_time", label: "Artist Pre-Sale" },
  { key: "public_on_sale_time", label: "Public On-Sale" },
];

export const ANCHOR_NAME = "Event Start";

export const activityRows = (form, extraShowDetailNames = []) => [
  ...SERIES_ACTIVITIES.map(({ key, label }) => ({ name: label, column: key })),
  ...(form.isDraft ? extraShowDetailNames : []).map((name) => ({ name })),
];

export const timingOf = (form, row) => {
  const offset = (form.showDetailOffsets || {})[row.name];
  if (offset !== undefined && offset !== null) return { offset: Number(offset) };
  const at = row.column ? (form.showActivityTimes || {})[row.column] : (form.showDetailTimes || {})[row.name];
  return at ? { at } : null;
};

const without = (map, name) => {
  const { [name]: _removed, ...rest } = map || {};
  return rest;
};

export const writeTiming = (form, setField, row, timing) => {
  const offset = timing && timing.offset !== undefined ? timing.offset : null;
  const at = timing && timing.at ? timing.at : null;
  setField("showDetailOffsets", offset === null ? without(form.showDetailOffsets, row.name) : { ...form.showDetailOffsets, [row.name]: offset });
  if (row.column) {
    setField("showActivityTimes", { ...form.showActivityTimes, [row.column]: at });
  } else {
    setField("showDetailTimes", at ? { ...form.showDetailTimes, [row.name]: at } : without(form.showDetailTimes, row.name));
  }
};

const unitLabel = (amount, unit) => (Number(amount) === 1 ? unit.replace(/s$/, "") : unit);

export const formatInstant = (value, timeZone, withYear = true) =>
  moment.tz(value, timeZone || moment.tz.guess()).format(withYear ? "MMM D, YYYY, h:mm A" : "MMM D, h:mm A");

export const describeTiming = (timing, timeZone) => {
  if (!timing) return null;
  if (timing.at) return `${formatInstant(timing.at, timeZone)} · same for all`;
  if (timing.offset === 0) return `At ${ANCHOR_NAME}`;
  const { amount, unit, direction } = offsetParts(timing.offset);
  return `${amount} ${unitLabel(amount, unit)} ${direction} ${ANCHOR_NAME}`;
};

export const landsAt = (timing, date, time, timeZone) => {
  if (!timing) return null;
  const zone = timeZone || moment.tz.guess();
  if (timing.at) return moment.tz(timing.at, zone);
  const start = moment.tz(`${date} ${time || "00:00"}`, "YYYY-MM-DD HH:mm", zone);
  const days = timing.offset / (24 * 60);
  return Number.isInteger(days) ? start.subtract(days, "days") : start.subtract(timing.offset, "minutes");
};
